/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DictionaryGroupVm,
    DictionaryGroupVmFromJSON,
    DictionaryGroupVmFromJSONTyped,
    DictionaryGroupVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface DictionaryGroupVmPaginatedSearchResponse
 */
export interface DictionaryGroupVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<DictionaryGroupVm>}
     * @memberof DictionaryGroupVmPaginatedSearchResponse
     */
    items?: Array<DictionaryGroupVm> | null;
    /**
     * 
     * @type {number}
     * @memberof DictionaryGroupVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryGroupVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryGroupVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryGroupVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryGroupVmPaginatedSearchResponse
     */
    size?: number;
}

export function DictionaryGroupVmPaginatedSearchResponseFromJSON(json: any): DictionaryGroupVmPaginatedSearchResponse {
    return DictionaryGroupVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function DictionaryGroupVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictionaryGroupVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(DictionaryGroupVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function DictionaryGroupVmPaginatedSearchResponseToJSON(value?: DictionaryGroupVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(DictionaryGroupVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


